import React, { useState } from 'react';
import { ErrorMessage, Field } from 'formik';
import Proptypes from 'prop-types';
import { formErrorMessage } from './FormErrorMessage';
import EyeIcon from '../svgIcons/EyeIcon';
import EyeHideIcon from '../svgIcons/EyeHideIcon';
import styled from 'styled-components';
import StyledInputWithIcon from '../styledComponents/StyledInputWithIcon';

const FormikIconInput = ({
  name,
  hideError = false,
  showCharacterCount = false,
  type = 'text',
  maxLength,
  onChange,
  $phColor = '',
  readOnly = false,
  ogUrlInput = false,
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const toggleShowPassword = () => setShowPassword(!showPassword);

  const handleInputChange = (e, setFieldValue) => {
    const inputValue = e.target.value;

    // Check if the input value exceeds the maxLength
    if (maxLength && inputValue.length > maxLength) {
      return;
    }

    // Update the field value
    setFieldValue(name, inputValue);
    onChange && onChange(e);
  };

  return (
    <Field name={name}>
      {({ field, form: { touched, errors, submitCount, setFieldValue } }) => (
        <>
          <StyledInputWithIcon
            {...field}
            type={
              type === 'password' ? (showPassword ? 'text' : 'password') : type
            }
            isinvalid={submitCount && touched[field.name] && errors[field.name]}
            id={props.id}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
              }
            }}
            onChange={(e) => handleInputChange(e, setFieldValue)} // Handle input change to limit length
            $phColor={$phColor}
            readOnly={readOnly}
            ogUrlInput={ogUrlInput}
            {...props}
          />
          {type === 'password' && (
            <div className="position-relative">
              <StyledIcon
                className="position-absolute cursor-pointer"
                style={{
                  top: '-22px',
                  right: '10px',
                  transform: 'translateY(-50%)',
                }}
                onClick={toggleShowPassword}
              >
                {showPassword ? <EyeHideIcon /> : <EyeIcon />}
              </StyledIcon>
            </div>
          )}
          <div className="d-flex justify-content-between">
            {!hideError && submitCount > 0 && (
              <ErrorMessage name={field.name} render={formErrorMessage} />
            )}
            {showCharacterCount && (
              <div className="ms-auto">
                Max {field?.value?.length}
                /250 characters
              </div>
            )}
          </div>
        </>
      )}
    </Field>
  );
};

const StyledIcon = styled.div`
  color: ${({ theme }) => theme.primaryDark};
`;

FormikIconInput.propTypes = {
  name: Proptypes.string.isRequired,
  placeholder: Proptypes.string,
  type: Proptypes.string,
  as: Proptypes.string,
  rows: Proptypes.string,
  maxLength: Proptypes.number, // New prop for limiting the length
};

export default React.memo(FormikIconInput);
